import { render, staticRenderFns } from "./PersonTable.vue?vue&type=template&id=395a251b&scoped=true"
import script from "./PersonTable.vue?vue&type=script&lang=js"
export * from "./PersonTable.vue?vue&type=script&lang=js"
import style0 from "./PersonTable.vue?vue&type=style&index=0&id=395a251b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395a251b",
  null
  
)

export default component.exports